import { useState } from 'react';
import React from 'react';
import { CreateRegistrationInput, RegistrationStatusEnum } from '../API';
import { createRegistrationRecord } from '../mutations/processCreateRegistration';

export function useAddGuest(eventId: string | undefined, onSuccess: () => void) {
  const [guestFirstName, setGuestFirstName] = useState('');
  const [guestLastName, setGuestLastName] = useState('');
  const [guestEmail, setGuestEmail] = useState('');
  const [addGuestLoading, setAddGuestLoading] = useState(false);
  const [guestFeedback, setGuestFeedback] = useState<string | null>(null);

  const handleAddGuest = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!eventId) return;
    setAddGuestLoading(true);
    setGuestFeedback(null);
    try {
      const input: CreateRegistrationInput = {
        eventId,
        email: guestEmail,
        firstName: guestFirstName,
        lastName: guestLastName,
        registrationStatus: RegistrationStatusEnum.REGISTERED,
        live: true,
        generateQRAndTicket: false,
      };
      const response = await createRegistrationRecord(input);
      if (response && response.registrationId) {
        setGuestFirstName('');
        setGuestLastName('');
        setGuestEmail('');
        onSuccess();
      } else {
        console.error('Add Guest: No registrationId in response', response);
        setGuestFeedback('Failed to add guest.');
      }
    } catch (err) {
      setGuestFeedback('Error adding guest.');
      console.error('Add Guest: Exception thrown', err);
    } finally {
      setAddGuestLoading(false);
    }
  };

  return {
    guestFirstName, setGuestFirstName,
    guestLastName, setGuestLastName,
    guestEmail, setGuestEmail,
    addGuestLoading,
    guestFeedback,
    handleAddGuest,
  };
}
